import React, { useContext } from 'react';

import SiteSeeContext from './SiteSeeContext';

import { ReactComponent as ArrowUp } from '../../SVGAssets/arrow-up.svg';
import { ReactComponent as FiltersIcon } from '../../SVGAssets/filters-icon.svg';

const SiteSeeFiltersGuide = () => {
  const { siteSeeName, actionWord, isMobile } = useContext(SiteSeeContext);

  return (
    <>
      {`${actionWord} the`}

      <span className="siteSeeGuide__icon siteSeeGuide__icon--inline">
        {isMobile ? <FiltersIcon /> : <ArrowUp />}
      </span>

      icon
      {' '}
      {isMobile ? `in the ${siteSeeName} control bar below ` : ''}
      to filter community residences by type, bedrooms, location, and floor plan.
    </>
  );
};

export default SiteSeeFiltersGuide;
